<template>
    <div class="tabs-toggles">
        <!-- start tabs menu -->
        <div class="tab-nav" :class="{'m-hide': isMixedMode, 'tab-nav-buttons': isButtonsStyle}" v-if="showTabNav">
            <div class="tabs-left" v-if="left.length">
                <div v-for="tab in left" :key="tab.title" class="tab" :class="{'tab-active': tab.isActive}" @click="selectTab(tab)">
                    <span class="icon symbol" v-if="tab.showIcon && tab.icon">
                        <svg class="icon">
                            <use :xlink:href="'/images/icon/'+tab.icon+'.svg#icon'"></use>
                        </svg>
                    </span>
                    <div class="txt" v-if="tab.showTitle && tab.title">{{ tab.title }}</div>
                </div>
            </div>

            <div class="tabs-right" v-if="right.length">
                <div v-for="tab in right" :key="tab.title" class="tab" :class="{'tab-active': tab.isActive}" @click="selectTab(tab)">
                    <span class="icon symbol" v-if="tab.showIcon && tab.icon">
                        <svg class="icon">
                            <use :xlink:href="'/images/icon/'+tab.icon+'.svg#icon'"></use>
                        </svg>
                    </span>
                    <div class="txt" v-if="tab.showTitle && tab.title">{{ tab.title }}</div>
                </div>
            </div>
        </div>
        <!-- end tabs menu -->

        <slot></slot>
    </div>
</template>

<script>
    const findByHash = tabs => window.location.hash ? tabs.find(tab => '#' + tab.hash === window.location.hash) : null;
    const findLastSelected = tabs => tabs.filter(tab => tab.selected).pop();

    export default {
        name: 'Tabs',

        props: {
            buttonsStyle: { type: Boolean, default: false },
            mode: {
                type: String,
                default: 'tabs',
                validator: value => ['tabs', 'accordion', 'mixed'].indexOf(value) !== -1,
            },
        },

        data() {
            return {
                tabs: [],
                isButtonsStyle: this.buttonsStyle
            };
        },

        created() {
            this.tabs = this.$children;
            window.addEventListener('hashchange', this.hashChanged, { passive: true });
        },

        beforeDestroy() {
            window.removeEventListener('hashchange', this.hashChanged);
        },

        mounted() {
            const selectedTab = findByHash(this.tabs) || findLastSelected(this.tabs) || (this.isTabsMode && this.tabs[0]);
            if (selectedTab) {
                this.selectTab(selectedTab);
            }
        },

        computed: {
            isTabsMode() {
                return this.mode === 'tabs';
            },
            isAccordionMode() {
                return this.mode === 'accordion';
            },
            isMixedMode() {
                return this.mode === 'mixed';
            },
            showTabNav() {
                return this.isTabsMode || this.isMixedMode;
            },
            showAccordionNav() {
                return this.isAccordionMode || this.isMixedMode;
            },
            left() {
                return this.tabs.filter(tab => !tab.right);
            },
            right() {
                return this.tabs.filter(tab => tab.right);
            },
        },

        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = selectedTab && (tab.title === selectedTab.title);
                })
            },

            hashChanged() {
                const selectedTab = findByHash(this.tabs);
                if (selectedTab) {
                    this.selectTab(selectedTab);
                }
            }
        }
    }
</script>
